






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import _ from 'lodash'

import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue'
import PageLoader from '@/components/page-loader/page-loader.vue'

import { i18nMixin } from '../../mixins'
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE } from '@/store/modules/authentication/types'
import { Client } from '@/store/modules/authentication/interfaces'
import { CountryType } from '@/enums/country.enum'
import { IKeyValue } from '@/interfaces/key-value-interface'
import { EnumHelpers } from '@/utils/enum.helpers'
import { DncCommonService } from '@/services/dnc.common.service'
import { traceLogAccess } from '@/services'
import { ContextEnum } from '@/enums/context.enum'
import { CONFIG } from '@/config'
import { LocationTypeEnum } from '../../model/types/enums/locationTypeEnum'
import { SaleTypeEnumDnc } from '../../model/types/enums/saleTypeEnumDnc'
import { PeriodicityType } from '../../model/types/enums/periodicity-typeEnum'
import { SpreadsheetTypeEnum } from '../../model/types/enums/spreadsheet-typeEnum'

interface iState {
  localeTypes: IKeyValue[]
  periodicities: IKeyValue[]
  filesType: IKeyValue[]
  salesType: IKeyValue[]

  placeholder: string
  idPeriodicitySelected: number
  idLocaleTypeSelected: number
  idFileTypeSelected: number
  idSaleType: number
}


@Component({
  name: 'DncReportPage',
  components: {
    KendoDropdown,
    PageLoader,
  },
})
export default class DncReportPage extends Vue {
  public readonly translate = i18nMixin.methods.i18n
  public SpreadsheetTypeEnum = SpreadsheetTypeEnum

  @Getter(AUTH_GET_CLIENT)
  public client!: Client

  @Getter(AUTH_GET_COUNTRY)
  public country!: CountryType

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType!: number

  public isExtractModalOpen: boolean = false
  public isLoading: boolean = false
  public isTierConsolidade: boolean = false

  @Watch('isExtractModalOpen')
  onExtractModalOpenChanged(newVal: boolean) {

    if (newVal === false) {
      this.$router.push('/');
    }
  }

  public state: iState = {
    localeTypes: [],
    periodicities: _.orderBy(
      _.map(EnumHelpers.TransformToKeyValue(PeriodicityType), (e: any) => {
        e.text = this.translate('Dnc.Periodicity.' + e.text)
        return e
      }),
      'desc'
    ),
    filesType: _.orderBy(
      _.map(EnumHelpers.TransformToKeyValue(SpreadsheetTypeEnum), (e: any) => {
        e.text = this.translate('Dnc.fileTypes.' + e.text)
        return e
      }),
      'desc'
    ),
    salesType: _.orderBy(
      _.filter(
        _.map(EnumHelpers.TransformToKeyValue(SaleTypeEnumDnc), (e: any) => {
          e.text = this.translate('Common.' + e.text)
          return e
        }),
      ),
      'desc'
    ),

    placeholder: 'Selecione',
    idPeriodicitySelected: 0,
    idLocaleTypeSelected: 0,
    idFileTypeSelected: 0,
    idSaleType: 0,
  }

  public get fileTypes(): IKeyValue[] {
    if (this.isTierConsolidade) {
      return this.state.filesType.filter(ft => +ft.value === SpreadsheetTypeEnum.Consolidate)
    }
    return this.state.filesType
  }
  public get saleTypes(): IKeyValue[] {
    return this.state.salesType
  }
  public get isFormValid(): boolean {
    const { idPeriodicitySelected, idLocaleTypeSelected, idFileTypeSelected, idSaleType } = this.state

    if (idFileTypeSelected === SpreadsheetTypeEnum.Result) {
      if (this.isTierConsolidade) {
        return idPeriodicitySelected > 0 && idLocaleTypeSelected !== 0 && idFileTypeSelected > 0
      }
      return idPeriodicitySelected > 0 && idLocaleTypeSelected !== 0 && idFileTypeSelected > 0 && idSaleType > 0
    }
    if (idFileTypeSelected === SpreadsheetTypeEnum.Consolidate) {
      return idPeriodicitySelected > 0 && idLocaleTypeSelected !== 0 && idFileTypeSelected > 0
    }
    return false
  }

  async mounted() {
    this.isExtractModalOpen = true
    await this.loadLocaleTypes()
    await this.loadTypeDNC()
  }

  private async loadLocaleTypes() {
    const localeCityValue = { name: LocationTypeEnum[LocationTypeEnum.City], value: LocationTypeEnum.City }
    const localeTypes = await DncCommonService.getLocaleTypes()
    localeTypes.push(localeCityValue)
    this.state.localeTypes = localeTypes.map((x: any) => ({
      text: x.name == 'City' ? this.translate('Common.City') : x.name,
      value: String(x.value),
    }))
  }

  private async loadTypeDNC() {
    this.isTierConsolidade = await DncCommonService.getDNCType()
  }

  public async downloadExtractDnc() {
    try {
      this.isLoading = true
      await DncCommonService.downloadExtractDnc(this.getUrlDownloadExtractDnc())
    } catch (e) {
      console.error(e)
    }
  }

  private getUrlDownloadExtractDnc() {
    const baseUrl = `${CONFIG.URL.NEODASH_API}/api/dnc/report/project/extract`
    const { idPeriodicitySelected, idLocaleTypeSelected, idSaleType } = this.state

    traceLogAccess.logAction(ContextEnum.Dnc, `Download`, JSON.stringify(this.state))

    switch (this.state.idFileTypeSelected) {
      case SpreadsheetTypeEnum.Result:
        if (this.state.idLocaleTypeSelected == LocationTypeEnum.City) {
          return `${baseUrl}/${idPeriodicitySelected}/${idSaleType}/city`
        }
        return `${baseUrl}/${idPeriodicitySelected}/${idSaleType}/${idLocaleTypeSelected}`

      case SpreadsheetTypeEnum.Consolidate:
        if (idLocaleTypeSelected == LocationTypeEnum.City) {
          return `${baseUrl}/consolidate/${idPeriodicitySelected}/city`
        }

        return `${baseUrl}/consolidate/${idPeriodicitySelected}/${idLocaleTypeSelected}`

      default:
        throw new Error('Parameter is invalid to generate download.')
    }
  }
}
